import React, { Component } from 'react'
// import { connect } from 'react-redux'

import './panel.scss'

import PanelHeader from '../panelHeader'
import HelpIcon from '../helpIcon'

class Panel extends Component {

  constructor (props) {
    super(props)
    this.state = {

    }
  }

  getSizeClass () {
    switch (this.props.size) {
      case undefined:
      case null:
      case 'l':
        return 'size-large'
      case 'm':
        return 'size-medium'
      case 's':
        return 'size-small'
    }
  }

  getTitleStyle () {
    return 'title ' + this.getSizeClass()
  }

  renderTitle (actions) {
    // if (this.props.title === null) return null
    if (typeof this.props.title === 'function') return this.props.title()

    return (
      <PanelHeader text={this.props.title} icon={this.props.icon}>
        {this.props.helpText !== null && <HelpIcon helpText={this.props.helpText} />}
        {actions}
        {/* {this.props.actions.length > 0 && this.props.actions.map((a, key) => ({ ...a, key }))} */}
      </PanelHeader>
    )
  }

  render () {
    let actions = null
    let children = this.props.children

    if (children && children[0]) {
      if (React.isValidElement(children[0]) && children[0].type.displayName === 'Actions') {
        const [ cActions, ...rest ] = children

        actions = cActions
        children = rest
      }
    }

    let containerCss = 'container'
    if (this.props.clearfix) containerCss += ' clearfix'

    return (
      <div className={'element-panel'} data-col={this.props.dataCol} id={this.props.id}>
        {this.renderTitle(actions)}
        <div className={containerCss}>
          {children}
        </div>
      </div>
    )
  }

}

Panel.defaultProps = {
  title: null,
  helpText: null,
  size: 'l',
  actions: [],
  dataCol: null,
  clearfix: false,
  id: null,
  icon: null
}

export default Panel



// WEBPACK FOOTER //
// ./src/app/shared/elements/panel/index.js